// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as HtmlEntities from "../../utils/HtmlEntities.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as FirebaseError from "../../backend/FirebaseError.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import SignInFormModuleCss from "./SignInForm.module.css";
import * as UnauthenticatedTemplate from "./UnauthenticatedTemplate.bs.jsx";

let classes = SignInFormModuleCss;

function get(state, field) {
  if (field === "Email") {
    return state.email;
  } else {
    return state.password;
  }
}

function set(state, field, value) {
  if (field === "Email") {
    return {
      email: value,
      password: state.password
    };
  } else {
    return {
      email: state.email,
      password: value
    };
  }
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

let wrongPasswordMessage = "@@wrong-password";

function SignInForm(props) {
  let onSignUp = props.onSignUp;
  let onSignInWithPassword = props.onSignInWithPassword;
  let onSignInWithPasskey = props.onSignInWithPasskey;
  let onSignInWithGoogle = props.onSignInWithGoogle;
  let onForgottenPassword = props.onForgottenPassword;
  let form = Form.use({
    email: "",
    password: ""
  }, Validators$1.schema([
    Validators$1.required("Email"),
    Validators$1.email("Email"),
    Validators$1.required("Password"),
    Validators$1.password("Password")
  ]), param => {
    let raiseSubmitFailed = param.raiseSubmitFailed;
    Stdlib_Promise.$$catch(onSignInWithPassword(param.state.values), error => {
      let match = FirebaseError.toFirebaseError(error);
      let errorMessage;
      if (match.RE_EXN_ID === FirebaseError.InvalidPassword) {
        errorMessage = wrongPasswordMessage;
      } else if (match.RE_EXN_ID === FirebaseError.TooManyRequests) {
        errorMessage = "Příliš mnoho pokusů o přihlášení. Zkuste to prosím později.";
      } else {
        let exn = Stdlib_Option.getOrThrow(Stdlib_JsExn.fromException(error), undefined);
        LogUtils.captureException(exn);
        let msg = Stdlib_JsExn.message(exn);
        errorMessage = msg !== undefined ? `Chyba: ` + msg : "Neznámá chyba";
      }
      raiseSubmitFailed(errorMessage);
      return Promise.resolve();
    });
  }, undefined, undefined, "OnDemand", undefined);
  let maybeErrorMessage = form.state.formState;
  let tmp;
  if (typeof maybeErrorMessage !== "object") {
    tmp = null;
  } else {
    let maybeErrorMessage$1 = maybeErrorMessage._0;
    tmp = <p
      className={Styles.messageBar.variantDanger}
      role={"alert"}
    >
      {maybeErrorMessage$1 !== undefined ? (
          maybeErrorMessage$1 !== wrongPasswordMessage ? maybeErrorMessage$1 : <>
              {`Špatný e` + HtmlEntities.nbhp + `mail nebo heslo. Máte problém s pamětí? `}
              <button
                className={Styles.link.base}
                type={"button"}
                onClick={param => onForgottenPassword(form.values.email)}
              >
                {`Obnovte heslo přes e` + HtmlEntities.nbhp + `mail.`}
              </button>
            </>
        ) : "Neznámá chyba"}
    </p>;
  }
  return <UnauthenticatedTemplate.make
    className={classes.root}
    isOnline={props.isOnline}
    loadingOverlay={props.loadingOverlay}
  >
    <h2>
      {"Přihlášení"}
    </h2>
    <Form.Provider.make
      value={form}
    >
      <form
        className={Styles.stack.base}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={`reset ` + Styles.fieldset.grid}
        >
          <Form.Field.make
            field={"Email"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"email"}
              inputSlot={<input
                autoComplete={"username email"}
                type={"email"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`E` + HtmlEntities.nbhp + `mail`}
            />}
          />
          <Form.Field.make
            field={"Password"}
            render={field => <InputWrapper.make
              inputError={field.error}
              inputName={"password"}
              inputSlot={<input
                autoComplete={"current-password"}
                type={"password"}
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              />}
              labelSlot={`Heslo`}
            />}
          />
        </fieldset>
        {tmp}
        <button
          className={Styles.button.base}
          type={"submit"}
        >
          {`Přihlásit se heslem`}
        </button>
      </form>
    </Form.Provider.make>
    <p>
      {`Nemáte účet? `}
      <button
        className={Styles.link.base}
        type={"button"}
        onClick={param => onSignUp()}
      >
        {`Zaregistrujte se.`}
      </button>
    </p>
    <section
      aria-labelledby={"other_methods"}
    >
      <h3
        id={"other_methods"}
      >
        <span>
          {"nebo"}
        </span>
      </h3>
      {onSignInWithPasskey !== undefined ? <button
          className={Styles.button.base}
          type={"button"}
          onClick={param => onSignInWithPasskey()}
        >
          {"Přihlásit otiskem"}
        </button> : null}
      <button
        className={Styles.button.base}
        type={"button"}
        onClick={param => onSignInWithGoogle()}
      >
        {"Přihlásit přes Google"}
      </button>
    </section>
  </UnauthenticatedTemplate.make>;
}

let make = SignInForm;

export {
  classes,
  FormFields,
  Form,
  Validators$1 as Validators,
  wrongPasswordMessage,
  make,
}
/* classes Not a pure module */
